import {createMuiTheme} from '@material-ui/core/styles';
import {ANIMATION_DEFINITIONS, ANIMATION_IDS} from '@makolab/library-react/dist/jssAnimations';
import themeRenault from '@makolab/library-react/dist/themeRenault';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

// https://material-ui.com/customization/themes/
// https://cimdalli.github.io/mui-theme-generator/

export const themeConfig = {
  ...themeRenault,
  mlbCustomVariables: { // put your custom project theme variables here
    animationIds: {...ANIMATION_IDS},
    animationDefs: {...ANIMATION_DEFINITIONS},
    svgIconUrl: `${PUBLIC_URL}/static/svg/dacia-icons-map.svg`,
    url: path => (
      `url(${PUBLIC_URL}${path})`
    )
  }
};

export default createMuiTheme(themeConfig);



// WEBPACK FOOTER //
// ./src/styles/theme-default.js